<template>
  <a href="#" v-show="!is_onTop">
    <div class="scroll-to-top">
      <i class="icon-arrow-up"></i>
    </div>
  </a>
</template>

<style lang="scss" scoped>
.scroll-to-top {
  background: $color-logo-1;
  position: fixed;
  bottom: 10px;
  right: 10px;
  font-size: 25px;
  color: white;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  z-index: 99;
}
</style>

<script>
export default {
  data() {
    return {
      is_onTop: true
    };
  },
  mounted() {
    this.checkTop();
  },
  methods: {
    checkTop() {
      window.onscroll = () => {
        if (window.pageYOffset < 200) {
          this.is_onTop = true;
        } else {
          this.is_onTop = false;
        }
      };
    }
  }
};
</script>